const config = {
    // The project name.
    name: 'Feel',

    // The environment.
    env: process.env.NODE_ENV || 'production',

    // The base URL to the portal.
    baseURL: 'https://dashboard-de.myfeel.co',

    // How to authenticate with Auth0.
    auth: {
        // The Auth0 account domain.
        domain: 'myfeel.auth0.com',

        // The Auth0 client ID.
        clientID: 'ZjK2SQdkb5dAIUcRRcK2f7RTyGpt3ewE'
    },

    // How to access the API.
    api: {
        // The base URL to the API.
        baseURL:
            'https://dashboard-de.myfeel.co/api/'
    },

    //The beacon Token
    beaconToken: '8bdbda6f-dff3-4b87-89e6-99e6509b1441'
}

module.exports = config



// WEBPACK FOOTER //
// ./src/config.js